var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{attrs:{"visible":_vm.pdfPreviewDialog,"title":"帮助文档","append-to-body":true,"width":"50%","center":""},on:{"update:visible":function($event){_vm.pdfPreviewDialog=$event},"close":_vm.closeDialog}},_vm._l((_vm.pageCount),function(i){return _c('pdf',{key:i,attrs:{"src":_vm.src,"page":i}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54aa1e02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/osNav/components/pdfDialog.vue
// module id = null
// module chunks = 